import { ChangeDetectorRef, Component } from '@angular/core';
import { AProgessBarWizardComponent } from '../../../components/common/progressbarwizard/iprogressbar.wizard.component';
import { SmartSyncService } from '../../../services/smart.sync.service';
import { MediaService } from '../../../services/media.service';

@Component({
    selector: 'siw-source-page',
    templateUrl: './siw.source.page.html',
    styleUrls: ['./siw.source.page.css']
})
export class SmartIntegrationWizardSourcePage extends AProgessBarWizardComponent {
    SearchText: string;
    FilteredSources: any[] = [];

    get CanStepForward(): boolean {
        return this.WizardState.SelectedDataSource != null;
    }

    constructor(private service: SmartSyncService, private cdRef: ChangeDetectorRef) {
        super();
    }
    OnWizardStateSet(): void {
        if (this.WizardState) {
            if (this.WizardState.UseCaseResult) {
                this.onSearchChanged();
            } else {
                this.service.GetUseCases().subscribe(x => {
                    const list = [];
                    for (let i = 0; i < 15; i++) {
                        list.push(...x);
                    }
                    this.WizardState.UseCaseResult = x;
                    if (x) {
                        const url = MediaService.ExternalImageURL.getValue();
                        x.forEach((ds: any) => {
                            if (ds.ExistingDataSources) {
                                ds.ExistingDataSources.forEach((eds: any) => {
                                    if (eds.Caption) {
                                        eds.SearchText = eds.Caption.toLowerCase();
                                    }
                                    if (ds.Icon) {
                                        eds.URL = url + ds.Icon;
                                    }
                                });
                            }
                            if (ds.UseCases) {
                                ds.UseCases.forEach((uc: any) => {
                                    if (uc.Caption) {
                                        uc.SearchText = uc.Caption.toLowerCase();
                                    }
                                });
                            }
                        });
                    }
                    this.onSearchChanged();
                });
            }
        }
    }

    onSearchChanged() {
        const filteredSources = []
        if (this.WizardState.UseCaseResult) {
            if (this.SearchText) {
                const toLower = this.SearchText.toLowerCase();
                this.WizardState.UseCaseResult.forEach((x: any) => {
                    if (x.ExistingDataSources) {
                        filteredSources.push(...x.ExistingDataSources.filter((y: any) => y.SearchText.includes(toLower)));
                    }
                });
            } else {
                this.WizardState.UseCaseResult.forEach((x: any) => {
                    if (x.ExistingDataSources) {
                        filteredSources.push(...x.ExistingDataSources);
                    }
                });
            }
        }
        this.FilteredSources = filteredSources;
        this.cdRef.detectChanges();
    }

    onDataSourceSelected(ds: any) {
        this.WizardState.SelectedDataSource = ds;
        this.WizardState.SelectedUseCase = null;
    }
}
